import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PlatformModule } from '@app/platform.module';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    standalone: true,
    imports: [PlatformModule, CommonModule],
    template: `<div class="text-align-right">
        {{ value }}
        <span class="vertical-label" *ngIf="this.prorated">
            <ui-badge type="default">{{ this.prorated }}</ui-badge>
        </span>
    </div>`,
})
export class CompensationTotalCellRenderer implements ICellRendererAngularComp {
    public value: any;
    public prorated: any;

    agInit(params: any): void {
        this.prorated = params.values.prorated;
        this.value = params.value;
    }

    refresh(params: ICellRendererParams) {
        return false;
    }
}
